import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  num: '1',
  value: '€27',
  title: 'Piano Alimentare 30 Giorni',
  desc: 'Un percorso guidato giorno per giorno.'
}, {
  num: '2',
  value: '€17',
  title: 'Lista della Spesa Premium',
  desc: 'Organizzata per categorie (Zero sprechi).'
}, {
  num: '3',
  value: '€27',
  title: 'Guida Snack & Dessert Healthy',
  desc: 'Il piacere dello spuntino senza colpa.'
}, {
  num: '4',
  value: '€27',
  title: 'Guida Anti-Gonfiore Mediterranea',
  desc: 'Strategie per sentirti sgonfio subito.'
}];
export function BonusSection() {
  return <section className="py-10 sm:py-16 px-4 bg-brand-sage-light relative overflow-hidden" data-id="element-29">
      <div className="max-w-2xl mx-auto relative z-10" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 sm:mb-10 flex flex-col items-center" data-id="element-31">
          <div className="bg-brand-gold/20 p-3 rounded-full mb-3" data-id="element-32">
            <GiftIcon className="w-7 h-7 sm:w-8 sm:h-8 text-brand-gold" data-id="element-33" />
          </div>
          <h2 className="text-xl sm:text-3xl font-serif font-bold text-brand-text-main mb-2" data-id="element-34">
            🎁 4 BONUS ESCLUSIVI INCLUSI
          </h2>
          <p className="text-sm sm:text-base text-brand-text-muted font-bold" data-id="element-35">
            Valore totale dei bonus: €98 — OGGI GRATIS
          </p>
        </motion.div>

        <div className="space-y-3 sm:space-y-4" data-id="element-36">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-white border border-brand-gold/30 p-4 sm:p-5 rounded-xl shadow-sm" data-id="element-37">
              <div className="flex items-center gap-2 mb-2" data-id="element-38">
                <span className="text-brand-gold font-black text-xs tracking-widest" data-id="element-39">
                  BONUS {bonus.num}
                </span>
                <span className="text-brand-text-muted/50" data-id="element-40">|</span>
                <span className="text-xs font-black text-brand-gold uppercase" data-id="element-41">
                  Valore {bonus.value} — GRATIS
                </span>
              </div>
              <h3 className="text-sm sm:text-base font-bold text-brand-text-main leading-tight mb-1" data-id="element-42">
                {bonus.title}
              </h3>
              <p className="text-xs sm:text-sm text-brand-text-muted font-medium leading-snug" data-id="element-43">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}